import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "appLayout" }
const _hoisted_2 = {
  key: 0,
  id: "navbar"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "absolute ms-4 -mt-1.5",
  width: "30",
  src: "https://www.scrapx.io/images/logo--png-4.png",
  alt: "ScrapX Logo"
}, null, -1)
const _hoisted_4 = { id: "routerView" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_progress = _resolveComponent("vue3-progress")!
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_vue3_progress),
      (_ctx.$route.name != 'website')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_NavBar)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createBlock(_component_router_view, {
          key: _ctx.$route.path
        }))
      ])
    ])
  ]))
}